import { gql } from "@apollo/client";

export const ASSIGN_PERSON_MUTATION = gql(/* GraphQL */ `
  mutation AssignStudentPersons($studentId: UUID!, $personIds: [UUID!]!) {
    assignStudentPersons(
      input: { studentId: $studentId, personIds: $personIds }
    ) {
      student {
        id
      }
    }
  }
`);
